module.exports = __webpack_public_path__ + "img/boky_08_cerna.1a276716.png";